// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__12JJH","overflowing":"ReadFullNote_overflowing__3K49m"};